const state = {
  showSidebar: false
};

const getters = {};

//actions
const actions = {
  getSiderStatus({ commit, dispatch }, data) {
    commit('setSiderbar', data);
    return data;
  }
};

// mutations
const mutations = {
  setSiderbar(state, data) {
    state.showSidebar = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js